function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.865 17.222c-.752.554-1.994.28-2.26-.82a1.437 1.437 0 00-2.145-.888c-1.286.784-2.758-.688-1.975-1.975a1.437 1.437 0 00-.888-2.143c-1.463-.355-1.463-2.437 0-2.792a1.437 1.437 0 00.889-2.144c-.783-1.286.688-2.758 1.975-1.975a1.435 1.435 0 002.143-.888c.355-1.463 2.437-1.463 2.792 0a1.437 1.437 0 002.144.889c1.286-.783 2.758.688 1.975 1.975a1.437 1.437 0 00.335 1.873M12.5 10a2.5 2.5 0 10-1.437 2.263M17.5 12.5h-2.083a1.25 1.25 0 000 2.5h.833a1.25 1.25 0 010 2.5h-2.083M15.833 17.5v.833m0-6.666v.833"
});

function SvgSettingsDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref);
}

export default SvgSettingsDollar;